import script from "./Ad.vue?vue&type=script&setup=true&lang=js"
export * from "./Ad.vue?vue&type=script&setup=true&lang=js"

import "./Ad.vue?vue&type=style&index=0&id=59cfdd6c&scoped=true&lang=css"

import exportComponent from "/Users/cindy/mydoc/project/vue-antd-tool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59cfdd6c"]])

export default __exports__